<template>
    <nav class="navbar has-background-primary" role="navigation" aria-label="main navigation">
        <div class="container">
            <div class="navbar-brand">
                <router-link class="navbar-item logo" to="/">
                <h1 class="has-text-white">READ-THAI</h1>
                </router-link>
                <div class="navbar-burger has-text-white" data-target="navbar-mobile-menu" @click="isActive = !isActive" v-bind:class="{ 'is-active': isActive }">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <b-modal :active.sync="isShowLogin" has-modal-card>
                <login></login>
            </b-modal>

            <div class="navbar-menu" id="navbar-mobile-menu" v-bind:class="{ 'is-active': isActive }">

                <div class="navbar-end">
                    <!-- navbar items -->
                    <div class="navbar-item is-hoverable">
                        <button class="button is-medium" v-show="!isAuthenticated" @click=showLogin>เข้าสู่ระบบ</button>
                    </div>

                    <button class="button is-info" v-show="isAdmin" @click="changeUser">Change user</button>

                    <b-dropdown class="navbar-item"
                    v-show="isAuthenticated"
                    v-model="navigation"
                    position="is-bottom-left">
                        <button class="button is-medium" slot="trigger">
                            <img :src=user.photoURL class="circle" v-if="user.photoURL"/>
                            <span>&nbsp; เมนู</span>
                            <b-icon icon="angle-down"></b-icon>
                        </button>
                        <b-dropdown-item custom v-show="user.displayName">
                            ชื่อที่แสดง: {{ user.displayName }}
                        </b-dropdown-item>
                        <b-dropdown-item custom v-show="user.email">
                            Email: {{ user.email }}
                        </b-dropdown-item>
                        <b-dropdown-item custom v-show="user.uid">
                            User ID: {{ user.uid }}
                        </b-dropdown-item>
                        <hr class="dropdown-divider">
                        <b-dropdown-item has-link>
                            <a href="https://m.me/xianni.thai/" target="_blank">
                                <b-icon icon="link"></b-icon>&nbsp; แจ้งปัญหา
                            </a>
                        </b-dropdown-item>
                        <b-dropdown-item value="/">
                            <b-icon icon="home"></b-icon>&nbsp; หน้าแรก
                        </b-dropdown-item>
                        <!-- <b-dropdown-item value="/profile">
                            <b-icon icon="user"></b-icon>&nbsp; My Profile
                        </b-dropdown-item> -->
                        <b-dropdown-item value="/subscriptions">
                            <b-icon icon="home"></b-icon>&nbsp; เลื่อนระดับขั้น
                        </b-dropdown-item>
                        <b-dropdown-item value="/payments">
                            <b-icon icon="book-open"></b-icon>&nbsp; ประวัติการโอนเงิน
                        </b-dropdown-item>
                        <hr class="dropdown-divider">
                        <!-- <b-dropdown-item value="/settings">
                            <b-icon icon="cog"></b-icon>&nbsp; Settings
                        </b-dropdown-item> -->
                        <b-dropdown-item class="is-danger" @click=logout>
                            <b-icon icon="sign-out-alt"></b-icon>&nbsp; ออกจากระบบ
                        </b-dropdown-item>
                    </b-dropdown>

                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { get, dispatch } from 'vuex-pathify'
import store from '../store'
import { db } from './../firebase.config'
const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login')

export default {
  components: {
    Login
  },
  data () {
    return {
      isActive: false,
      isShowLogin: false
    }
  },
  computed: {
    isAuthenticated () {
      return Object.keys(this.user).length !== 0
    },
    user: get('user'),
    isAdmin: get('isAdmin'),
    navigation: {
      get () {
        return this.$route.path
      },
      set (newValue) {
        this.$router.push(newValue)
      }
    }
  },
  methods: {
    showLogin () {
      this.isShowLogin = true
    },
    logout () {
      dispatch('logout')
    },
    changeUser () {
      this.$dialog.prompt({
        message: `your user email: ${this.user.email} <br><b>user id</b>: ${this.user.uid}`,
        inputAttrs: {
          type: 'text',
          placeholder: this.user.email
        },
        onConfirm: (value) => {
          this.user.uid = value
          store.dispatch('autoSignIn', this.user)
          db.collection('payments').where('user_email', '==', value)
            .get()
            .then(snapshot => {
              this.$root.payments = snapshot.docs.map(payment => payment.data())
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
    .circle {
        border-radius: 50%;
    }
    .logo .title {
        color: white;
    }
</style>
